export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/animated.bbe4c60.svg";